import { VisitaInfo } from "../../../../types/visitas";
import EditRoundedIcon from '@mui/icons-material/EditRounded';

interface Props {
    visita: VisitaInfo;
    onEditButton?: () => void;
}

export function VisitDetailsInfo({ visita, onEditButton }: Props) {
    return (
        <div>
            <div className="flex justify-between">
                <p className="font-semibold text-lg pb-2">Información de la visita</p>

                {!visita.terminado && (
                <div 
                    className="hover:bg-gray-100 rounded-md w-[25px] h-[25px] flex justify-center items-center cursor-pointer"
                    onClick={onEditButton}>
                    <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                </div>
                )}
            </div>

            <div className="flex gap-x-3 justify-between">
                <div>
                    <label className="text-sm font-semibold">Fecha</label>
                    <input 
                        disabled
                        value={visita?.fecha}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm" />
                </div>

                <div>
                    <label className="text-sm font-semibold">Hora de inicio</label>
                    <input
                        value={visita?.horaInicio}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"/>
                </div>

                <div>
                    <label className="text-sm font-semibold">Hora de fin</label>
                    <input
                        value={visita?.horaFin}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"/>

                </div>
            </div>

            <div className="grid grid-cols-1 gap-x-2">

                <div>
                    <label className="text-sm font-semibold">Turno</label>
                    <input
                        value={visita.turno}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm" />
                </div>

            </div>
        </div>
    );
}